var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.sharedContent.length ? _c('div', [_c('v-subheader', [_vm._v(" " + _vm._s(_vm.title) + " ")]), _vm.isLoading ? _c('v-card', {
    staticClass: "mb-1",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-skeleton-loader', {
    attrs: {
      "type": "list-item-two-line"
    }
  })], 1) : _vm._l(_vm.sharedContent, function (shared) {
    return _c('v-card', {
      key: shared.id + 'shared',
      staticClass: "mb-1",
      attrs: {
        "outlined": ""
      }
    }, [_c('refs-shared-content', {
      attrs: {
        "item": shared,
        "confirmable": true
      },
      on: {
        "openDetail": function openDetail($event) {
          return _vm.onSharedContentClick(shared);
        }
      }
    })], 1);
  }), _vm.selectedSharedContent ? _c('shared-content-side-card', {
    attrs: {
      "value": _vm.selectedSharedContent
    },
    on: {
      "close": function close($event) {
        _vm.selectedSharedContent = null;
      }
    }
  }) : _vm._e()], 2) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }